import { Module } from "vuex";
import { RootState } from "../index";
import { ElMessage } from "element-plus";
import {
  getUsers,
  getUser,
  toggleVip,
  createComment,
  refreshUser,
} from "@/shared/api/users";
import { IUsers, ISubscription, IOffer, IComment } from "@/shared/types/users";

export interface IState {
  data: IUsers;
  user: IUser;
}

export interface IUser {
  subscriptions: ISubscription[];
  offers: IOffer[];
  comments: IComment[];
}

const usersModule: Module<IState, RootState> = {
  namespaced: true,
  state: {
    data: {} as IUsers,
    user: {} as IUser,
  },
  mutations: {
    SET_LIST(state, response) {
      state.data = response;
    },
    SET_USER(state, response) {
      state.user = response;
    },
    // TOGGLE_VIP(state, data) {},
    ADD_COMMENT(state, data) {
      state.user.comments.push(data);
    },
  },
  actions: {
    async getUsers({ commit }, payload) {
      try {
        const response = await getUsers(payload);
        if (response && response.data) {
          commit("SET_LIST", response.data);
          return response.data;
        } else {
          throw response.message;
        }
      } catch (e: any) {
        ElMessage({
          message: e,
          type: "error",
        });
      }
    },
    async getUser({ commit }, payload) {
      try {
        const response = await getUser(payload);
        if (response && response.data) {
          commit("SET_USER", response.data);
          return response.data;
        } else {
          throw response.message;
        }
      } catch (e: any) {
        ElMessage({
          message: e,
          type: "error",
        });
      }
    },
    async toggleVip({ commit }, payload) {
      try {
        console.log("toggle vip:", payload);
        const response = await toggleVip(payload);
        console.log("toggle vip:", response);
        if (response && response.data) {
          commit("TOGGLE_VIP", response.data);
          return response.data;
        } else {
          throw response.message;
        }
      } catch (e: any) {
        ElMessage({
          message: e,
          type: "error",
        });
      }
    },
    async createComment({ commit }, payload) {
      try {
        const response = await createComment(payload);
        if (response && response.data) {
          commit("ADD_COMMENT", response.data);
          return response.data;
        } else {
          throw response.message;
        }
      } catch (e: any) {
        ElMessage({
          message: e,
          type: "error",
        });
      }
    },
    async refreshUser(_, payload) {
      try {
        const response = await refreshUser(payload);
        if (!response?.data) {
          throw response.message;
        }
      } catch (e: any) {
        ElMessage({
          message: e,
          type: "error",
        });
      }
    },
  },
};

export default usersModule;
